/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Add_Frame_To_EndInputs */



/**
* | output |
* | --- |
* | "Increase end time by one frame" |
*
* @param {Shortcut_Keys_Desc_Add_Frame_To_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_add_frame_to_end = /** @type {((inputs?: Shortcut_Keys_Desc_Add_Frame_To_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Add_Frame_To_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Augmenter le temps de fin d'une image")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erhöhe die Endzeit um ein Frame.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aumenta l'ora di fine di un fotogramma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличьте время окончания на один кадр.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aumentar el tiempo de finalización en un cuadro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("结束时间增加一帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終了時間を1フレーム増やす")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समाप्ति समय को एक फ्रेम से बढ़ाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aumente o tempo final em um quadro.")
	return /** @type {LocalizedString} */ ("Increase end time by one frame")
});